import { api, errorFn } from "@/common/apiService";
import {
  SUBMIT_REPORT
} from "../actions/marshal";

const state = {
};

const getters = {
};

const actions = {
  [SUBMIT_REPORT]: ({commit, dispatch, rootState}, report) => {
    const body = JSON.stringify(report);
    console.log(body);
    return api.post('/rm-reports/', body).then((resp) => {
      console.log("Report submitted");
      commit(SUBMIT_REPORT, report)
    }).catch(errorFn)
  },
};

const mutations = {
  [SUBMIT_REPORT]: (state, REP) => {

  },
};

export default {
  state,
  getters,
  actions,
  mutations
};
